import React from 'react';
import { dummyCallback } from '../../utils/complexDocumentConstants';
import { CustomModal } from './Styles';

const ReusableModal = ({
  visible = false,
  title = 'Modal Title',
  onOk = dummyCallback,
  onCancel = dummyCallback,
  footer = null,
  width = '416',
  styleProps = {},
  bodyStyleProps = {},
  children,
  centered = false,
  maskClosable = false,
  className = 'reusableModal',
  mask=true,
  transitionName = undefined,
  afterClose=dummyCallback
}) => {
  return (
    <CustomModal
      destroyOnClose={true}
      title={title}
      visible={visible}
      onOk={onOk}
      onCancel={onCancel}
      footer={footer}
      width={width}
      style={{ ...styleProps }}
      bodyStyle={{ ...bodyStyleProps }}
      centered={centered}
      maskClosable={maskClosable}
      className={className}
      mask={mask}
      transitionName={transitionName}
      maskStyle={{ animationDuration: '0.8s' }}
      afterClose={afterClose }
    >
      {children}
    </CustomModal>
  );
};

export default ReusableModal;
